export default {
      id: "btn_info-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "sprite.svg#btn_info",
      toString: function () {
        return this.url;
      }
    }